import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async fetchAll(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/report/sale-item', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
